export default __webpack_public_path__ + "static/media/sandero-colour-2.d42eca65.jpg";